<template>
  <b-modal
    ref="grupoNotificacaoModal"
    class="w-100"
    title="Cadastro de Grupos de Notificação"
    hide-footer
    no-close-on-backdrop
    no-close-on-esc
    size="lg"
  >
    <template #modal-header>
      <b-button
        variant="none"
        class="btn-none rounded-pill icone-acao"
        @click="fechar"
      >
        <font-awesome-icon
          :icon="['fas', 'xmark']"
          size="xl"
          color="var(--primary)"
        />
      </b-button>
    </template>
    <cadastro-base
      :is-modal="true"
      :salvar="salvar"
      :cancelar-cadastro="fechar"
    >
      <template slot="conteudo">
        <b-row>
          <b-col cols="12">
            <b-alert
              variant="info"
              show
            >
              Crie grupos de notificação a partir de grupos de permissão ou personalize com usuários específicos.
            </b-alert>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
            <b-form-group label="Nome do grupo de notificação">
              <b-form-input
                v-model="form.nome"
                placeholder="escreva o nome do grupo de notificação aqui!"
              />
            </b-form-group>
          </b-col>
        </b-row>

        <!-- Exibir placeholders desse evento -->
        <b-row v-if="form.eventoNotificacaoId">
          <b-col cols="12">
            <b-link
              href="#"
              class="text-primary"
              @click.prevent="showPlaceholders = !showPlaceholders"
            >
              Exibir placeholders desse evento
            </b-link>
            <b-collapse
              v-model="showPlaceholders"
              class="mt-2"
            >
              <b-card>
                <b-list-group>
                  <b-list-group-item
                    v-for="placeholder in placeholders"
                    :key="placeholder"
                    class="cursor-pointer"
                    @click="insertPlaceholder(placeholder)"
                  >
                    {{ placeholder.codigo }} - {{ placeholder.descricao }}
                  </b-list-group-item>
                </b-list-group>
              </b-card>
            </b-collapse>
          </b-col>
        </b-row>

        <!-- Usuário interno select -->
        <b-row>
          <b-col cols="12">
            <usuario-interno-select
              v-model="form.usuariosInternos"
              :require="true"
              multiple
            />
          </b-col>
        </b-row>

        <!-- grupo permissão usuário select -->
        <b-row class="mb-2">
          <b-col cols="12">
            <grupo-usuario-select
              v-model="form.grupos"
              :require="true"
              :multiple="true"
            />
          </b-col>
        </b-row>
      </template>
    </cadastro-base>
  </b-modal>
</template>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import CadastroBase from '@/shared/components/cadastro-base/CadastroBase.vue'
import api from '@/app-modulo/comuns/notificacao/shared/services/api'
import UsuarioInternoSelect from '@/shared/components/usuario-interno-select/UsuarioInternoSelect.vue'
import GrupoUsuarioSelect from '@/shared/components/grupo-usuario-select/GrupoUsuarioSelect.vue'

export default {
  name: 'GrupoNotificacaoModal',
  components: {
    FontAwesomeIcon,
    CadastroBase,
    UsuarioInternoSelect,
    GrupoUsuarioSelect,
  },
  data() {
    return {
      form: {
        id: null,
        nome: '',
        grupos: [],
        usuariosInternos: [],
        ativo: false,
      },
      eventosNotificacao: [],
      tiposNotificacao: [],
      editorOptions: {
        modules: {
          toolbar: [
            ['bold', 'italic', 'underline', 'strike'],
            ['blockquote', 'code-block'],
            [{ header: 1 }, { header: 2 }],
            ['image'],
            [{ list: 'ordered' }, { list: 'bullet' }],
            [{ indent: '-1' }, { indent: '+1' }],
            [{ size: ['small', false, 'large', 'huge'] }],
            [{ header: [1, 2, 3, 4, 5, 6, false] }],
            [{ color: [] }, { background: [] }],
            [{ font: [] }],
            [{ align: [] }],
          ],
        },
        placeholder: [
          'Escreva sua mensagem aqui.',
          'Você pode adicionar imagens, links e formatações de texto.',
          'Use as opções acima para personalizar sua mensagem.',
        ],
      },
      placeholders: [],
      showPlaceholders: false,
    }
  },
  mounted() {
  },
  methods: {
    fechar() {
      this.$refs.grupoNotificacaoModal.hide()
    },
    abrir(id = null) {
      if (id) {
        // Buscar os dados do registro pelo ID
        api.getGrupoNotificacaoById(id)
          .then(response => {
            this.form = { ...response.data }
            this.$refs.grupoNotificacaoModal.show()
          })
          .catch(err => {
            this.$handleError(err)
          })
      } else {
        // Resetar o formulário para criação
        this.form = {
          id: null,
          nome: '',
          grupos: [],
          usuariosInternos: [],
          ativo: false,
        }
        this.$refs.grupoNotificacaoModal.show()
      }
    },
    salvar() {
      return new Promise((resolve, reject) => {
        if (!this.form.nome) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Preencha todos os campos para prosseguir!',
              icon: 'AlertCircleIcon',
              variant: 'danger',
            },
          })
          reject()
        } else {
          // Garante que grupos seja um array de objetos GrupoDTO completo
          const gruposFormatados = Array.isArray(this.form.grupos)
            ? this.form.grupos.map(g => ({
              id: g.id,
              nome: g.nome,
              descricao: g.descricao || null,
              externo: g.externo || false,
              administrador: g.administrador || false,
              permitidoDownloadA1Cnpj: g.permitidoDownloadA1Cnpj || false,
              permitidoDownloadA1Cpf: g.permitidoDownloadA1Cpf || false,
              // Adicione outros campos se necessário
            }))
            : []

          const payload = {
            id: this.form.id,
            nome: this.form.nome,
            grupos: gruposFormatados,
            usuariosInternos: this.form.usuariosInternos,
          }

          const apiCall = this.form.id
            ? api.atualizaGrupoNotificacao(this.form.id, payload) // Atualização
            : api.criaGrupoNotificacao(payload) // Criação

          apiCall
            .then(() => {
              this.fechar()
              this.$emit('notification-group-saved', this.form)
              this.form = {
                id: null,
                nome: '',
                grupos: [],
                usuariosInternos: [],
                ativo: false,
              }
              resolve('Notificação salva com sucesso!')
            })
            .catch(err => {
              reject(err)
            })
        }
      })
    },
    buscaGruposDeUsuario() {
      api.getEventosNotificacoes()
        .then(payload => {
          this.eventosNotificacao = payload.data.map(evento => ({
            text: evento.nome,
            value: evento.id,
          }))
        }).catch(err => {
          this.$handleError(err)
        })
    },
    buscaUsuariosInternos() {
      api.getTiposNotificacao()
        .then(payload => {
          this.tiposNotificacao = payload.data.map(tipo => ({
            text: tipo.nome,
            value: tipo.valor,
          }))
        }).catch(err => {
          this.$handleError(err)
        })
    },
    insertPlaceholder(placeholder) {
      // Inserir o placeholder no editor
      const editor = this.$refs.quillEditor.quill
      if (editor) {
        const range = editor.getSelection(true)
        editor.insertText(range.index, `{{${placeholder.codigo}}}`, 'user')
        this.showPlaceholders = false
      }
    },
  },
}
</script>

<style src="@core/scss/vue/libs/quill.scss" lang="scss"></style>
<style lang="scss">
.ql-editor {
  overflow: auto;
  min-height: 300px;
  max-height: 700px;

  &::-webkit-scrollbar-track {
    border-radius: 10px;
    background-color: #f5f5f5;
  }

  &::-webkit-scrollbar {
    width: 10px;
    background-color: #f5f5f5;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background-color: #bfbfbf;
  }
}

.suggestions-dropdown {
  position: absolute;
  background: white;
  border: 1px solid #ccc;
  border-radius: 4px;
  z-index: 1000;
  max-height: 150px;
  overflow-y: auto;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2);
}

.suggestions-dropdown ul {
  list-style: none;
  margin: 0;
  padding: 0;
}

.suggestions-dropdown li {
  padding: 8px 12px;
  cursor: pointer;
  transition: background-color 0.2s;
}

.suggestions-dropdown li:hover {
  background: #f0f0f0;
}

.suggestions-dropdown li.active {
  background: #e8f0fe;
  color: #1a73e8;
}

.placeholder-label {
  padding: 5px 10px;
  font-size: 12px;
  font-weight: bold;
  color: #666;
  background: #f5f5f5;
  border-bottom: 1px solid #ddd;
}

.editor-container {
  position: relative;

  .ql-editor {
    min-height: 250px;
    max-height: 500px;
    overflow-y: auto;
  }

  .placeholder-dropdown {
    position: absolute;
    width: 250px;
    background: white;
    border: 1px solid #ccc;
    border-radius: 4px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
    z-index: 1000;
    top: 50px;
    left: 0;

    .placeholder-title {
      padding: 8px 12px;
      background: #f5f5f5;
      border-bottom: 1px solid #ddd;
      font-weight: bold;
      color: #555;
    }

    .placeholder-item {
      padding: 8px 12px;
      cursor: pointer;

      &:hover {
        background: #f0f0f0;
      }
    }
  }
}
</style>
